module.exports = __webpack_public_path__ + "static/media/VTB_220.0301df0d.png";